import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PricingData from "../../data/pricing/PricingData.json";
import { FaCheck } from "react-icons/fa";

const categories = [
  { id: "development", label: "Development" },
  { id: "digital-marketing", label: "Digital Marketing" }
];

const PricingOne = () => {
  const [activeCategory, setActiveCategory] = useState(categories[0].id);

  useEffect(() => {
    // default to Development on mount
    setActiveCategory(categories[0].id);
  }, []);

  const handleCategoryClick = (catId) => {
    setActiveCategory(catId);
  };

  // Filter data by category and take top 3
  const visibleCourses = PricingData
    .filter((c) => c.category === activeCategory)
    .slice(0, 3);

  return (
    <>
      <div className="pricing-billing-duration">
        <ul className="nav">
          {categories.map((cat) => (
            <li className="nav-item" key={cat.id}>
              <button
                onClick={() => handleCategoryClick(cat.id)}
                className={`nav-link ${cat.id === activeCategory ? "active" : ""}`}
                type="button"
              >
                {cat.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div className="row">
        {visibleCourses.map((course) => (
          <div className="col-lg-4" key={course.id}>
            <div className="online-courses pricing-borderd">
              <div className="pricing-header">
                <h3 className="title">{course.title}</h3>
                <span className="subtitle">{course.subtitle}</span>
                {/* <div className="price-wrap"> */}
                  {/* <div className="yearly-pricing">
                    <span className="amount">{course.price}</span>
                    <span className="duration">{course.duration}</span>
                  </div> */}
                {/* </div> */}
                <div className="pricing-btn">
                  {/* Link to a course detail or checkout route */}
                  <Link to={`/courses/${course.id}`} className="axil-btn btn-large btn-borderd">
                    Enroll Now
                  </Link>
                </div>
              </div>

              {/* <div className="pricing-body">
                <ul className="list-unstyled">
                  {course.facility && course.facility.map((f, idx) => (
                    <li key={idx}>
                      <FaCheck /> {f}
                    </li>
                  ))}
                </ul>
              </div> */}
            </div>
          </div>
        ))}

        {visibleCourses.length === 0 && (
          <div className="col-12">
            <p>No courses available in this category yet.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default PricingOne;
